goog.provide('el8.app.shared.dialog.reportAttachments');

goog.require('el8.app.pageLayout');

goog.require('el8.app.shared.dialog.reportAttachmentGroups');
goog.require('el8.appchart.showItemDetail');
goog.require('el8.ptdata.fetch');
goog.require('el8.template.app.shared.dialog.reportItemsAttachments');
goog.require('el8.uiwidget.GroupedNav');

//
// Dialog to attach reports to maint items and for close-the-loop based on selectAttachments.js
//
// This is stripped down from the very complex letters attachments dialog. It only shows
// Reports, the popular nav section is removed, there's no indication of the currently
// selected attachment. to make a use limited-purpose dialog. Same the groups
//
el8.app.shared.dialog.reportAttachments = (function() {
    var groupedNav = null;
    var groups = null;

    var attachedItems = {};
    var callbackFn = null; // Won't error if null, but this dialog is pretty useless without one
    var patientId = null; // Optional -- Used for CTL from practice home

    var that = new el8.uiwidget.NewDialog({
        title: 'Attach a Report',
        modal: true,
        // has fixed height divs so is wonky with autoheight
        height: function() {
            return el8.app.pageLayout.getAppInnerHeight() - 170;
        },
        width: 800,
        contentFn: function() {
            return el8.template.app.shared.dialog.reportItemsAttachments.content({attachments: []});
        }
    });
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'save', 'Attach Item', function() {
            if (callbackFn) {
                callbackFn(_.values(attachedItems));
            }
            el8.util.amplitude.logUpdateStatusFulfilled('Attach Item');
            that.hide();
        }, true
    );
    buttonSet.addButton(
        'cancel', 'Cancel', function() {
            el8.util.amplitude.logUpdateStatusFulfilled('Cancel');
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        bindTriggers();
    };

    var super_show = that.show;

    that.show = function(spec) {
        callbackFn = spec.callbackFn || null;
        patientId = spec.patientId || null;

        super_show.call(that);

        // Reset content and re-bind
        that.setContent(el8.template.app.shared.dialog.reportItemsAttachments.content({attachments: []}));
        bindTriggers();

        // clear previous state
        _.each($(that.getContentElt()).find('div.el8BlueHighlightList'), function(div) {
            var $div = $(div);
            $div.toggleClass('el8BlueHighlightList');
            $($('input', $div)[0]).prop('checked', false);
        });

        // Move group init here since we only now know the pt id
        // Generate the "groups" for the GroupedNav widget below


        groups = el8.app.shared.dialog.reportAttachmentGroups.groups({
            allReportTypes: true,
            patientId: patientId
        });

        el8.app.shared.dialog.reportAttachmentGroups.setIsAttachedFn(checkIsAttached);
        groupedNav = new el8.uiwidget.GroupedNav({
            navContainer: $('.select-attachments-nav', that.getContentElt()),
            contentContainer: $('.select-attachments-content', that.getContentElt())
        });
        groupedNav.init({ groups: groups });
        groupedNav.showSection('lab');

        that.adjustPosition();

        syncButtonState();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        attachedItems = {};
        callbackFn = null;
        patientId = null;
        groupedNav = null;
    };

    // This is probably broken... and not needed
    that.ensureFeedRefresh = function(name) {
        // var feed = el8.appchart.letters.attachmentGroups.getFeedByName(name);
        // if (!feed) { return; }
        // if (groupedNav.getShowingSection() === name) {
        //     feed.update();
        // } else {
        //     feed.markNeedsUpdate();
        // }
    };

    //
    // Helper Functions
    //
    // Unlike letter attachment code, we just return the report id
    function attachItem(id) {
        id = parseInt(id, 10);
        if (isNaN(id)) { return; } // just in case
        var stringId = String(id);
        attachedItems[stringId] = el8.ptdata.reports.getById(id);
    }

    function attachUnknown(id) {
        attachItem(id);
    }

    function bindTriggers() {
        var $contentContainer = $('.select-attachments-content', that.getContentElt());
        var $attachmentList = $('.attachments-list', that.getContentElt());
        var $both = $('.select-attachments-content, .attachments-list', that.getContentElt());

        $contentContainer.on('click', '.attachment-checkbox',  function(e) {
            var $this = $(this);
            var $attachmentDiv = $this.closest('.attachment-div');
            if (_.isEmpty(attachedItems)) {
                // fired with nothing selected
                $attachmentDiv.toggleClass('el8BlueHighlightList');
                changeAttachedState($attachmentDiv.data('id'), $this.is(':checked'));
            } else {
                // fired with something selected
                var newId = $(this).closest('.attachment-div').data('id');
                var currentId = parseInt(_(attachedItems).keys()[0], 10);

                if (newId === currentId) {
                    // same thing selected again -- unselect
                    $attachmentDiv.toggleClass('el8BlueHighlightList');
                    changeAttachedState($attachmentDiv.data('id'), $this.is(':checked'));

                } else {
                    // different thing selected -- unselect the current thing, select the new thing
                    // unselect the current thing
                    var oldAttachmentDiv = $("div[data-id='" + currentId +"']")[0];
                    var $oldAttachmentDiv = $(oldAttachmentDiv);
                    $oldAttachmentDiv.toggleClass('el8BlueHighlightList');
                    $($('input', $oldAttachmentDiv)[0]).prop('checked', false); // uncheck
                    changeAttachedState(currentId, false); // remove old id

                    // select the new things
                    $attachmentDiv.toggleClass('el8BlueHighlightList');
                    changeAttachedState($attachmentDiv.data('id'), $this.is(':checked'));
                }
            }

            // clicking on the checkbox already toggles its checked state
            e.stopPropagation(); // and we don't need to trigger .attachment-div after this

            syncButtonState();
        });

        // shared code for clicking on an attachment div directly or clicking on an X button
        var attachmentDivClickFn = function($this) {
            // TODO use same code as above
            // if (!$this || !$this.length) { return; }
            // $this.toggleClass('el8BlueHighlightList');
            // var checkBox = $this.find('input');
            // checkBox.prop('checked', !checkBox.prop('checked')); //toggle the checkbox's state
            // changeAttachedState($this.data('id'), checkBox.is(':checked'));
        };

        $contentContainer.on('click', '.attachment-div',  function() {
            // attachmentDivClickFn($(this));
        });

        $both.on('click', '.item-details-trigger',  function() {
            var id = $(this).data('id');
            el8.appchart.showItemDetail(id);
            return false;
        });

        $attachmentList.on('click', '.remove-attachment',  function() {
            var $this = $(this);
            var $div;

            // try to find the .attachment-div corresponding to the attachment being removed
            var id = $this.data('id');
            var $div = getAttachmentDivById(id);

            if ($div && $div.length) {
                // if we found one, do the same stuff we would do it were clicked on
                attachmentDivClickFn($div);
            } else {
                // otherwise, this came from a visit note's referenced reports and was never
                // rendered / clicked on by the user - just remove the attachment
                changeAttachedState(id, false);
            }
        });

        // signed off reports actually get added with a call in reportFeeds.js' signOffCallBackFn
        el8.ptdata.reports.bind('all', function(eventName, arg, arg2) {
            if (eventName === EVENTS.MOVED) {
                // update both feeds that changed for a moved report
                var updatedReport = arg;
                var oldType = arg2;
                that.ensureFeedRefresh(updatedReport.getReportType());
                that.ensureFeedRefresh(oldType);
            } else {
                // for all other events, just refresh this report's feed
                that.ensureFeedRefresh(arg.getReportType());
            }
            // and always refresh the popular feed, in case the report was in there
            that.ensureFeedRefresh('popular');
        });
    }

    // If newlyAttached is true, attach this item; if it's false, remove the attachment.
    // Then re-render the attachments list.
    function changeAttachedState(itemId, newlyAttached) {
        var stringId = String(itemId);
        if (!newlyAttached) {
            delete attachedItems[stringId];
        } else {
            attachUnknown(itemId);
        }
    }

    // Used by attachmentGroups to see if an item should be rendered as selected
    function checkIsAttached(mClass, item) {
        if (_.contains(el8.data.attachablePrintouts, mClass)) {
            return Boolean(attachedItems[mClass]);
        } else if (item) {
            return Boolean(attachedItems[String(item.getId())]);
        }
        return false;
    }

    // id might be a pseudo_class for printouts
    function getAttachmentDivById(id) {
        return $('.attachment-div[data-id="'+id+'"]', that.getContentElt());
    }

    // enable/disable button based on UI state
    function syncButtonState() {
        if (_.values(attachedItems).length > 0) {
            buttonSet.enableButton('save');
        } else {
            buttonSet.disableButton('save');
        }
    }

    return that;

})();
